const PIXEL_ID = '1651867393151331'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

let initialized = false

function loadPixelScript() {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  } as NonNullable<Window['fbq']>

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)
}

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  loadPixelScript()
  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

export function trackAddToCart(params?: {
  content_name?: string
  value?: number
  currency?: string
}) {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart', {
    content_name: 'Organiza Tu Vida en 7 Días',
    content_type: 'product',
    value: 9,
    currency: 'USD',
    ...params,
  })
}
